import React from 'react';
import { IBreakdownCompare } from  '@/interfaces/insightsp2';
import DirectionIcon from './DirectionIcon'

const PrecentLabel = ({item}:{item:IBreakdownCompare}):JSX.Element =>  {

    return (
        <>
            <DirectionIcon numberDirection={item.direction} />
            <span>{item.percent.toString()}%</span>
        </>
    )
}

export default PrecentLabel;